<template>
    <BaseInfoDetail>
      <dl class="fee-estimate">
        <div class="term-group">
          <dt>Registration fee estimate</dt>
          <dd>{{ estimate }}</dd>
        </div>
      </dl>
    </BaseInfoDetail>
</template>


<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { toCurrency } from '@/utils/helpers';
import * as COMMONS from '../../../store/_commons';
import BaseInfoDetail from '../../ui/BaseInfoDetail';

const store = useStore();

const quoteEstimateInfo = computed(() => store.getters[COMMONS.QUOTE_ESTIMATE_INFO]);

const estimate = computed(() => {
  return toCurrency(quoteEstimateInfo.value?.registrationFee);
});
</script>


<style lang="scss" scoped>
.fee-estimate {
  width: 100%;
  .term-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1em;
    justify-content: space-between;
  }
}
</style>
